import React from "react";
import { Navigate } from "react-router-dom";

const Index = (props: any) => {
  return (
    <div>
      <Navigate to="/landing-page" />
    </div>
  );
};

export default Index;
